module.exports = __webpack_public_path__ + "img/slide7.6c4b7aa2.jpg";